import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function EncounterVehicleType({ data }) {
    const encounterByVehicleTypeChart = useMemo(() => {
        const source = data?.encountersByVehicleType || [];

        return {
            labels: source.map(item => ReportUtils.formatText(item.vehicle)),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "encounter-by-vehicle-type",
            encounterByVehicleTypeChart.values,
            encounterByVehicleTypeChart.labels,
            false,
            true,
            "",
            30,
        );

        if (encounterByVehicleTypeChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                encounterByVehicleTypeChart.labels,
                encounterByVehicleTypeChart.values,
                "Tipos de veículos abordados",
            );
        }
    }, [encounterByVehicleTypeChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Tipos de veículos abordados</span>
                <div className="mt-3" id="encounter-by-vehicle-type" />
            </div>

            <div className="chart-divisor" />
        </>
    )
}